import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';

import {
  getUsers,
  selectUser,
  selectAllUsers,
  deselectAllUsers,
  filterUserData,
  viewAllUsers,
  viewBannedUsers,
  resetUsersData,
  deleteSelected,
} from 'modules/memberLogin/modules/users/actions';
import { getGroups } from 'modules/memberLogin/modules/groups/actions';

import Livestream from './Livestream';
import { updateChecked, toggleBan, addLivestreamComponent } from './actions';
import { appHasComponent } from '../../../../utils';

const mapStateToProps = (state, ownProps) => {
  const appname = ownProps.match.params.appname;
  const livestreamComponentEnabled = appHasComponent(
    state.editor.structure,
    'Livestream',
  );
  return {
    ...ownProps,
    ...state.auth.users,
    accountId: state.account.auth.profile.account,
    appname: _get(
      state,
      `editor.shared.appName.${appname}.meta.title`,
      appname,
    ),
    livestreamComponentEnabled,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getUsers: () => dispatch(getUsers(ownProps.match.params.appname)),
  getGroups: () => dispatch(getGroups(ownProps.match.params.appname)),
  onUpdateChecked: (hasLivestreamAccess, user) =>
    dispatch(
      updateChecked(ownProps.match.params.appname, hasLivestreamAccess, user),
    ),
  onToggleBan: (livestreamBanned, user) =>
    dispatch(toggleBan(ownProps.match.params.appname, livestreamBanned, user)),
  onAddLivestreamComponent: () =>
    dispatch(
      addLivestreamComponent(ownProps.match.params.appname, ownProps.history),
    ),
  onSelect: key => dispatch(selectUser(key)),
  onSelectAllUsers: () => dispatch(selectAllUsers()),
  onDeselectAllUsers: () => dispatch(deselectAllUsers()),
  onFilterUserData: filter => dispatch(filterUserData(filter)),
  onViewAllUsers: () => dispatch(viewAllUsers()),
  onViewBannedUsers: () => dispatch(viewBannedUsers()),
  resetUsersData: () => dispatch(resetUsersData()),
  onDeleteSelected: (selected, chunks) =>
    dispatch(deleteSelected(ownProps.match.params.appname, selected, chunks)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Livestream),
);
